var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetadataLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 6.65674H0V2.65674C0 2.12631 0.210714 1.6176 0.585786 1.24252C0.960859 0.867452 1.46957 0.656738 2 0.656738L6 0.656738V2.65674H2V6.65674Z",
    fill: "#056EE6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6.65674H14V2.65674H10V0.656738H14C14.5304 0.656738 15.0391 0.867452 15.4142 1.24252C15.7893 1.6176 16 2.12631 16 2.65674V6.65674Z",
    fill: "#056EE6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 16.6567H10V14.6567H14V10.6567H16V14.6567C16 15.1872 15.7893 15.6959 15.4142 16.071C15.0391 16.446 14.5304 16.6567 14 16.6567Z",
    fill: "#056EE6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 16.6567H2C1.46957 16.6567 0.960859 16.446 0.585786 16.071C0.210714 15.6959 0 15.1872 0 14.6567V10.6567H2V14.6567H6V16.6567Z",
    fill: "#056EE6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetadataLogo);
export default __webpack_public_path__ + "static/media/MetadataLogo.efd8f89e627c90ca21eb801d483891cb.svg";
export { ForwardRef as ReactComponent };